import { createClient } from '@wix/sdk';
import { site } from '@wix/site';
import { STORES_APP_DEF_ID } from '../flow-api-adapter/consts';

type GlobalWixContext = {
  client?: unknown;
};

const isWixSdkClient = (client: unknown): boolean => {
  if (!client || typeof client !== 'object') {
    return false;
  }

  return (
    typeof (client as { use?: unknown }).use === 'function' &&
    typeof (client as { fetchWithAuth?: unknown }).fetchWithAuth === 'function'
  );
};

declare global {
  // eslint-disable-next-line no-var
  var __wix_context__: GlobalWixContext | undefined;
}

// The currency the shopper is browsing in, taken from the same place the platform takes
// it — the `currency` query param the currency converter puts on the URL.
export const getDisplayCurrency = () =>
  new URLSearchParams(globalThis.window.location.search).get('currency') ??
  undefined;

const createInstanceAuth = (instance?: string) =>
  instance
    ? {
        getAuthHeaders: async () => ({
          headers: {
            Authorization: instance,
          },
        }),
      }
    : undefined;

export const enableWixSdkContext = (
  isSSR: boolean,
  instance?: string,
  displayCurrency?: string,
) => {
  if (isSSR || typeof globalThis.window === 'undefined') {
    return;
  }

  if (isWixSdkClient(globalThis.__wix_context__?.client)) {
    return;
  }

  const wixClient = createClient({
    auth: createInstanceAuth(instance),
    // The Stores SDK rides this client instead of the flow's httpClient, so the platform
    // never adds the display-currency aspect to it and the picker would enrich products
    // in the site currency.
    headers: displayCurrency
      ? { 'x-wix-currency': displayCurrency }
      : undefined,
    host: site.host({ applicationId: STORES_APP_DEF_ID }),
  });

  wixClient.enableContext('global');
};
